import React, { useEffect, useRef, useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { studentAccountEdit } from '../../../Store/api/activities';
import editing from '../../../assets/images/editing.svg';
import CustomInput from '../../../components/dashboard/Tabs/Settings/CustomInput';
import Pencil from '../../../assets/images/pencil.svg';
import storage from '../../../services/storage';
import ArrowRight from '../../../assets/images/Arrow-right-dark.svg';
export default function AccountInformation() {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [userInfo, setUserInfo] = useState(user);
  const [isPasswordEditing, setIsPasswordEditing] = useState(false);
  const [err, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setUserInfo(user);
  }, [user]);

  const changeHandler = (e) => {
    setError(null);
    setUserInfo((old) => {
      return { ...old, [e.target.name]: e.target.value };
    });
  };
  useEffect(() => {
    setError(null);
  }, [userInfo]);

  return (
    <div className='box_border_settings'>
      <div className='settings_header'>
        <h2>account information</h2>
        <div className='settings_header'>
          <p
            className='mb-0 editt cursor'
            onClick={() => {
              setIsEditing((o) => !o);
              setIsPasswordEditing(false);
            }}
          >
            {isEditing ? 'editing' : 'edit'}
          </p>
        </div>
      </div>
      {isLoading ? (
        'Loading...'
      ) : (
        <Fragment>
          <div className='setting_rows'>
            <p className='key'>Email</p>
            <p className='value'>
              <input type='text' value={user.email} />
            </p>
          </div>
          {isEditing ? (
            <Fragment>
              {!isPasswordEditing ? (
                <div className='setting_rows'>
                  <p className='key'>Password</p>
                  <p className='value'>
                    <input type='text' readOnly value='********' className='main_part' />
                    {isEditing && (
                      <p
                        className='edit_buttton cursor'
                        onClick={() => {
                          setIsPasswordEditing(true);
                        }}
                      >
                        <img src={Pencil} alt='' />
                      </p>
                    )}
                  </p>
                </div>
              ) : (
                <Fragment>
                  <div
                    className='setting_rows justify-content-between'
                    style={{ alignItems: 'start' }}
                  >
                    <p className='key'>Password</p>
                    <div style={{ width: '67%' }}>
                      <input
                        type='password'
                        name='oldPassword'
                        placeholder='Old password'
                        className='form-control'
                        style={{ display: 'block', marginBottom: '4px' }}
                        onChange={changeHandler}
                      />
                      <input
                        type='password'
                        placeholder='New password'
                        name='newPassword'
                        className='form-control'
                        style={{ display: 'block', marginBottom: '4px' }}
                        onChange={changeHandler}
                      />
                      <input
                        type='password'
                        placeholder='Confirm new password'
                        name='confirmPassword'
                        className='form-control'
                        style={{ display: 'block', marginBottom: '4px' }}
                        onChange={changeHandler}
                      />
                    </div>
                    <p
                      className='edit_buttton cursor'
                      onClick={() => {
                        setIsPasswordEditing(false);
                      }}
                    >
                      <img className='white-to-black' src={Pencil} alt='' />
                    </p>
                  </div>
                </Fragment>
              )}
            </Fragment>
          ) : (
            <div className='setting_rows'>
              <p className='key'>Password</p>
              <p className='value'>
                <input type='text' readOnly value='********' className='main_part' />
                {isEditing && (
                  <p
                    className='edit_buttton cursor'
                    onClick={() => {
                      setIsPasswordEditing(true);
                    }}
                  >
                    <img src={Pencil} alt='' />
                  </p>
                )}
              </p>
            </div>
          )}
          <CustomInput
            isEditing={isEditing}
            type={'tel'}
            title={'Phone number'}
            name={'phoneNumber'}
            value={userInfo.phoneNumber}
            onChange={changeHandler}
          />
          <CustomInput
            isEditing={isEditing}
            title={'School'}
            name={'school'}
            value={userInfo.school}
            onChange={changeHandler}
          />
          <CustomInput
            isEditing={isEditing}
            title={'School timezone'}
            name={'schoolTimeZone'}
            value={userInfo.schoolTimeZone}
            onChange={changeHandler}
          />

          {isEditing && (
            <div className='setting_rows' style={{ marginBottom: '0px' }}>
              <p className='key'></p>
              <p className='value' style={{ justifyContent: 'end' }}>
                <p className='main_part' style={{ color: 'red' }}>
                  {err && `${err}`}
                </p>
                <p
                  className='edit_buttton cursor'
                  onClick={() => {
                    let er = '';
                    // if (!userInfo.school) {
                    //   er = 'School is required.';
                    // }
                    // if (!userInfo.schoolTimeZone) {
                    //   er = 'School timezone is required.';
                    // }

                    // Validate password fields if filled
                    if (userInfo.newPassword) {
                      if (!userInfo.confirmPassword) {
                        er = 'Confirm password is required.';
                      } else if (userInfo.confirmPassword !== userInfo.newPassword) {
                        er = 'Password and confirm password must match.';
                      } else if (!userInfo.oldPassword) {
                        er = 'Old password is required.';
                      }
                    }

                    if (er) {
                      setError(er);
                      return;
                    }

                    const hasUpdated =
                      userInfo.school !== user.school ||
                      userInfo.schoolTimeZone !== user.schoolTimeZone ||
                      userInfo.phoneNumber !== user.phoneNumber ||
                      (userInfo.newPassword && userInfo.newPassword !== '');

                    if (!hasUpdated) {
                      setIsEditing(false);

                      // setError('No changes to save.');
                      return;
                    }

                    const apiBody = {
                      school: userInfo.school,
                      schoolTimeZone: userInfo.schoolTimeZone,
                      phoneNumber: userInfo.phoneNumber,
                    };

                    if (userInfo.newPassword) {
                      apiBody.password = userInfo.newPassword;
                      apiBody.oldPassword = userInfo.oldPassword;
                      apiBody.confirmPassword = userInfo.confirmPassword;
                    }

                    setError(null);
                    setIsLoading(true);

                    dispatch(
                      studentAccountEdit({
                        body: apiBody,
                        onSuccess: (res) => {
                          setIsEditing(false);
                          setIsPasswordEditing(false);
                          setIsLoading(false);
                          storage.store('user', res.data.data);
                        },
                        onError: (error) => {
                          setIsLoading(false);
                          if (error.response?.data?.message) {
                            setError(error.response.data.message);
                          } else {
                            setError('Something went wrong!');
                          }
                        },
                      })
                    );
                  }}
                >
                  Save <img src={ArrowRight} alt='save' className='ms-1' />
                </p>
              </p>
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
}
